
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { getPlatform } from "@/util/get-platform";

@Component({
  components: {}
})
export default class RightClickMenuItem extends Vue {
  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: "" })
  shortcut!: string;

  @Prop({ default: () => [] })
  subItems!: any[];

  get isMac() {
    const platform = getPlatform().toLowerCase();
    return /mac/.test(platform);
  }
}
